var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiuxnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 75.19,
    width: 87.095,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.64099,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M.825.82h85.444v53.129H.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.64099,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M33.478 58.933h20.139V69.39H33.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.65086,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M.825 53.949h85.444v4.333H.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76291,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M18.531 69.451h50.033v4.858H18.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0bf",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.64099,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M4.856 8.02h17.235v12.781H4.856zm.145 16.46H57.48v5.616H5.001zm0 8.327H57.48v5.616H5.001zm0 8.327H57.48v5.616H5.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0bf",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.69181,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M26.315 8.104H57.37v12.635H26.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0bf",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.84242,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M62.547 8.316h19.591v38.257H62.547z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxnb);
export default __webpack_public_path__ + "static/media/UIUXNB.b18a5ea378199c6aa343c698adffa5a1.svg";
export { ForwardRef as ReactComponent };